import React, { useContext } from "react";
import { useState } from "react";

import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

import { Box, Button, Snackbar } from "@mui/material";

import CadernoLayout from "../../../Styles/layout/cadernoLayout";

import { ProducaoAnimalForm } from "./reg_prod_animal";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { ICabecalho7, IObservacoes, IProducaoAnimal } from "../../../Interfaces/cadernos/caderno7";
import { CabecalhoForm } from "./cabecalho";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { post } from "../../../Services/tokenConfig";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { func_print } from "../../../Func_genericas/func_print";
import { Alert } from "../../../Components/Alert/Alert";
import { ICaderno } from "../../../Interfaces/cadernos/caderno1";
import { FilterByData } from "../../../Func_genericas/filter_by_data";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
        },
        contents: {
            flexGrow: 1,
            padding: theme.spacing(0),
        },
        toolbars: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(2, 3),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
    })
);

export default function RegProducaoAnimal() {
    const classes = useStyles();


    const [obj_anexo_cabecalho_selecionado, set_obj_anexo_cabecalho_selecionado] = useState<ICabecalho7 | undefined>();
    const [rows, setRows] = useState<IProducaoAnimal[]>([]);
    const [rows_filtrada, setRows_filtrada] = useState<IProducaoAnimal[]>([]);


    return (
        <div className={classes.root}>
            <CadernoLayout title="7 - Registo de Produção Animal" />
            <main className={classes.contents}>
                <div className={classes.toolbars} />
                <Box width="80%" margin="auto">
                    <BeneficiarioNomeIdAlinhadoDireita />
                </Box>

                <FilterByData
                    listas={[
                        {
                            lista_original: rows,
                            set_lista_filtrada: setRows_filtrada,
                            campoData: "data_camp1",
                        },

                    ]}
                />
                <CabecalhoForm
                    obj_anexo_cabecalho_selecionado={obj_anexo_cabecalho_selecionado}
                    set_obj_anexo_cabecalho_selecionado={set_obj_anexo_cabecalho_selecionado}
                />


                {obj_anexo_cabecalho_selecionado !== undefined ?

                    <ProducaoAnimalForm

                        idCabecalho={obj_anexo_cabecalho_selecionado.id_registo_pro}
                        rows={rows}
                        rows_filtrada={rows_filtrada}
                        setRows={setRows}
                        setRows_filtrada={setRows_filtrada}
                    />
                    :
                    <></>
                }


            </main>
        </div>
    );
}